import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store';
import { gainDimensionPower } from '../store/slices/resourceSlice';
import { increaseDimensionRiftProgress } from '../store/slices/worldSlice';
import { Button } from './ui/button';
import { Progress } from './ui/progress';

/**
 * ゲームの主要コンテナコンポーネント
 * ゲームビューとクリックイベントを管理します
 */
const GameContainer: React.FC = () => {
  const dispatch = useDispatch();
  const resources = useSelector((state: RootState) => state.resources);
  const player = useSelector((state: RootState) => state.player);
  const world = useSelector((state: RootState) => state.world);
  
  // クリックパワーの計算（後でロジックを拡張予定）
  const calculateClickPower = () => {
    return 1 + Math.floor(player.level / 10);
  };
  
  // クリックでディメンションパワーを獲得
  const handleClick = () => {
    const clickPower = calculateClickPower();
    dispatch(gainDimensionPower(clickPower));
    
    // 一定確率で次元の亀裂の進行度を上昇させる
    if (Math.random() < 0.1) {
      dispatch(increaseDimensionRiftProgress(0.1));
    }
  };
  
  return (
    <div className="game-container p-4 h-full flex flex-col">
      <div className="world-info mb-4">
        <h2 className="text-xl font-bold">
          {world.currentWorldId === 'fantasy' ? '剣と魔法の世界' : '未知の世界'}
        </h2>
        <div className="dimension-rift-progress mt-2">
          <div className="text-sm">次元の亀裂: {world.dimensionRiftProgress.toFixed(1)}%</div>
          <Progress 
            value={world.dimensionRiftProgress} 
            className="w-full h-2 mt-1"
            indicatorColor="bg-blue-500" 
          />
        </div>
      </div>
      
      <div className="flex-grow flex items-center justify-center">
        <Button 
          variant="game"
          size="circle"
          onClick={handleClick}
          className="shadow-lg"
        >
          クリック
        </Button>
      </div>
      
      <div className="resources-display mt-4 grid grid-cols-2 gap-2">
        <div className="resource-display">
          <span>次元パワー:</span>
          <span className="font-bold">{resources.dimensionPower.toFixed(0)}</span>
        </div>
        <div className="resource-display">
          <span>次元の欠片:</span>
          <span className="font-bold">{resources.dimensionFragments}</span>
        </div>
        <div className="resource-display">
          <span>転生ポイント:</span>
          <span className="font-bold">{resources.transcendencePoints}</span>
        </div>
        {resources.worldSpecificResources.magic !== undefined && (
          <div className="resource-display">
            <span>魔力:</span>
            <span className="font-bold">{resources.worldSpecificResources.magic.toFixed(0)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default GameContainer; 